import React from 'react';
import ProjectTemplate from '../components/ProjectTemplate';

const ContainPage = () => {
  const media = [
      '/images/sync.webp', 
      '/images/morph.webp', 
      '/images/turmoil.webp'
  ];

  return (
    <div className="contain-page">
      
      <ProjectTemplate
        title="[CONTAIN]"
        year="2019"
  sections={[
    {
      type: 'description',
      text: '[CONTAIN] is an audio-visual composition consisting of three short etudes which are often played in succession. They are an attempt to bring different disciplines together; linking the sound of analogue beats and granular atmospheres to computer generated imagery, uniting the flashes of club culture to synaesthetic movements and bridging the internal angles of a cube with grainy waves of landscapes. The third part of this work Turmoil has received the second prize for the Punto Y Raya abstract film festival 2020.',
    },
    {
      type: 'image',
      links: [
        {
          src: media[0],
          href: 'https://www.youtube.com/watch?v=9QYFHe6205w',
          text: 'S Y N C'
        }, 
        {
          src: media[1],
          href: 'https://www.youtube.com/watch?v=nHsUbDa6Pgw',
          text: 'M O R P H'
        }, 
        {
          src: media[2],
          href: 'https://www.youtube.com/watch?v=ku3PpN3P60g',
          text: 'T U R M O I L'
        }, 
        
      ],
      isLink: true,
    }
  

  ]}
/>    
     

    </div>
  );
};

export default ContainPage;
